import { z } from 'zod';

// To be considered remote access we need both parameters
// Please, note that URL search params are string, so the only
// valid value for remote is string literal: 'true'
export default z
  .object({
    remote: z.literal('true'),
    returnUrlManage: z.string().url()
  });
